import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var SortAscendingSvg = function SortAscendingSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22 6.403-1.033.973-2.65-2.494v17.367h-1.46V4.882l-2.65 2.494-1.034-.973 4.414-4.154zM13.69 11.475H7.845v1.375h5.845zM4.923 16.06h8.767v1.375H4.923zM13.69 22.02v-1.376H2v1.376z"
  }));
};
export var SortAscending = function SortAscending(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: SortAscendingSvg
  }));
};